<cb-dialog>
    @if (!(locationsLoaded && supplyTypesLoaded)) {
        <cb-loading-spinner message="Please wait, loading.." class="cb-margin">
        </cb-loading-spinner>
    }
    <form class="flex-col flex" #defaultSupplierForm="ngForm">
        @if (!invalidSupplier && locationsLoaded && supplyTypesLoaded) {
            <div>
                @if (isEdit()) {
                    <cb-display-value-new
                        label="Supply Type"
                        [value]="mappedItem?.supplyType?.label"
                    >
                    </cb-display-value-new>
                }
                @if (isAdd()) {
                    <cb-select
                        [required]="true"
                        name="selectedSupplyTypeId"
                        label="Supply Type"
                        [(ngModel)]="selectedSupplyTypeId"
                        (change)="selectedSupplyTypeChanged()"
                        [options]="availableSupplyTypes"
                    >
                    </cb-select>
                }
                <cb-business-accounts-input-find-cards
                    label="Business Account"
                    [(ngModel)]="selectedSupplier"
                    name="selectedSupplier"
                    [text]="selectedSupplier?.tradingName"
                    [disabled]="!selectedSupplyTypeId"
                    [required]="true"
                    [searchParams]="businessAccountSearchParams"
                    (change)="supplierChanged()"
                >
                </cb-business-accounts-input-find-cards>
            </div>
        }
    </form>
    @if (invalidSupplier && locationsLoaded && supplyTypesLoaded) {
        <div class="flex-row">
            <mat-card class="cb-error-card">
                <mat-card-content>
                    <p>
                        Unable to link a supply type because this Business Entity is not linked to
                        any location.
                    </p>
                    <p>
                        Please visit <b>Settings</b> > <b>Locations</b> to configure a location for
                        this Business Entity.
                    </p>
                </mat-card-content>
            </mat-card>
        </div>
    }
    <div actions>
        <span class="flex"></span>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="
                defaultSupplierForm.invalid || defaultSupplierForm.pristine || invalidSupplier
            "
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
